export default {
  Create: "/tcs/take-survey",
  Detail: "/tcs/take-survey",
  SchemaQuestionList: "/tcs/take-survey/schema/question-list",
};
